'use client';
import React from 'react';

import { FaArrowRight } from 'react-icons/fa6';
import Link from 'next/link';
import NextImage from '@/features/Image';
import parse from 'html-react-parser';
import { parse as parseUrl } from 'url';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import { BannerSkeleton } from '../../banner/components/BannerSkeleton';
import { useAuth } from '@/features/authentication/hooks/auth';
import { useRouter } from 'next/navigation';

type SkinCareData = {
  title: string;
  description: string;
  banner: string;
  banner_web: string;
  btn_name: string;
  route: string;
  is_active: string;
};

const SkinCareWithAI = () => {
  const router = useRouter();
  const { user } = useAuth({ redirectIfAuthenticated: 'goBack' });

  // const homeThings = await fetcher('/api/v2/home-things?for=desktop');
  const { data: homeThings, isLoading } = useFetcherCSR(
    `/api/v2/home-things?for=desktop`
  );
  const data = homeThings?.homepage_settings?.recommendation;
  if (!homeThings?.homepage_settings?.features?.skin_concern) return null;
  if (isLoading) return <BannerSkeleton />;

  const linkPath = data?.route
    ? parseUrl(data.route).pathname
    : '/personal-recommendation/skincare-recommendation';

  const handleButton = () => {
    if (!user) return router.push(`/login`);
    router.push(linkPath || '');
  };
  return (
    <section className="sale-banner padding-top padding-bottom">
      <div className="container">
        <div
          className="sale-banner__wrapper"
          data-aos="fade-up"
          data-aos-duration={1000}
        >
          <div className="sale-banner__item sale-banner__item--style1">
            <div className="sale-banner__item-inner">
              <div className="sale-banner__item-thumb">
                <NextImage
                  width={410}
                  height={224}
                  className="sale-banner__image "
                  src={data?.banner_web || '/images/product/sale-banner/11.png'}
                  alt="Fresh vegetables"
                  style={{ inlineSize: '43.5ch' }}
                />
              </div>
              <div className="sale-banner__item-content">
                <h2>{data?.title}</h2>

                {data?.description && parse(data?.description)}
                <button
                  onClick={handleButton}
                  className="trk-btn trk-btn--primary  trk-btn--xlg mt-2 mt-lg-4"
                >
                  {data?.btn_name}
                  <span>
                    <FaArrowRight />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkinCareWithAI;
